import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Body2, Button, Dialog, Label, RadioButton } from "@activecollab/components";
import PropTypes from "prop-types";

export const CalendarEventRescheduleDialog = ({
  options = [],
  open,
  disabled,
  title,
  labelText,
  explainerText,
  submitBtnText,
  onSubmit,
  onCancel,
  onClose,
}) => {
  const { t } = useTranslation();
  const [action, setAction] = useState(() => null);

  const label = useCallback(
    (type) => {
      switch (type) {
        case "only_this_event":
          return t("Only this event");
        case "this_and_following_events":
          return t("This and following events");
        case "all_events":
          return t("All events");
        default:
          return "";
      }
    },
    [t]
  );

  const handleCancel = useCallback(() => {
    if (typeof onCancel === "function") {
      onCancel();
    }
  }, [onCancel]);

  const handleSave = useCallback(async () => {
    if (typeof onSubmit === "function") {
      onSubmit(action);
    }
  }, [action, onSubmit]);

  const handleChange = useCallback((e) => {
    setAction(e.target.value);
  }, []);

  useEffect(() => {
    if (options.length > 0) {
      setAction(options[0]);
    }
  }, [options]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <Dialog.Title>{title}</Dialog.Title>
      <Dialog.ContentDivider />
      <Dialog.Content className="tw-flex tw-flex-col tw-gap-4">
        <Body2>{labelText}</Body2>
        <div className="tw-flex tw-flex-col tw-gap-2">
          {options.map((option) => (
            <div
              key={option}
              className="tw-flex tw-gap-[6px] tw-items-center"
            >
              <RadioButton
                id={option}
                checked={action === option}
                value={option}
                onChange={handleChange}
              />

              <Label
                htmlFor={option}
                className="tw-cursor-pointer"
                weight="regular"
              >
                {label(option)}
              </Label>
            </div>
          ))}
        </div>
        {explainerText && action === "all_events" ? <Body2>{explainerText}</Body2> : null}
      </Dialog.Content>
      <Dialog.ContentDivider />
      <Dialog.Actions>
        <Button
          type="submit"
          variant="primary"
          className="tw-mr-3"
          onClick={handleSave}
          disabled={disabled}
        >
          {submitBtnText}
        </Button>
        <Button
          type="button"
          onClick={handleCancel}
          variant="secondary"
          disabled={disabled}
        >
          {t("Cancel")}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

CalendarEventRescheduleDialog.propTypes = {
  options: PropTypes.array,
  open: PropTypes.bool,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  labelText: PropTypes.string,
  explainerText: PropTypes.string,
  submitBtnText: PropTypes.string,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
};
